<div class="al-data-field" [ngClass]="{ 'al-data-field--inline': inline }">
    <div class="al-data-field__label">{{ label }}</div>
    <div class="al-data-field__value">{{ value }}</div>
</div>
